import { QueryClient } from '@tanstack/react-query';

/**
 * PERF-006: Configuration optimisée de React Query
 * - staleTime: 5 minutes - les données sont fraîches pendant 5 min
 * - gcTime: 10 minutes - les données en cache sont gardées 10 min après inactivité
 * - refetchOnWindowFocus: false - pas de refetch automatique au focus
 * - refetchOnMount: false si les données sont fraîches
 * - retry: 1 seule tentative en cas d'erreur
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes - données considérées fraîches
      gcTime: 1000 * 60 * 10, // 10 minutes - cache gardé après inactivité
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: 'always', // Toujours refetch au mount pour avoir les dernières données
      refetchOnReconnect: true, // Refetch si reconnexion réseau
    },
    mutations: {
      retry: 0, // Pas de retry sur les mutations
    },
  },
});